import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { JwtInterceptor } from './intercepter';
import { ForgotPassComponent } from './pages/forgot-pass/forgot-pass.component';
import { LoginComponent } from './pages/login/login.component';
import { ValidationComponent } from './pages/validation/validation.component';
import { VinInformationComponent } from './pages/vin-information/vin-information.component';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';

import { CommonRatingModule } from './pages/vam/commonrating/commonrating.module';
import { RatingModule } from './pages/vam/rating/rating.module';
import { VamModule } from './pages/vam/vam.module';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { JwtModule, JwtModuleOptions } from '@auth0/angular-jwt';
import { IonicModule } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ClickOutsideModule } from 'ng-click-outside';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { CommonCompModule } from './common/common-comp.module';
import { CommonratingcomponentsModule } from './commonratingcomponents/commonratingcomponents.module';
import { ComponentsModule } from './components/components.module';
import { OfflinePwaInterceptor } from './intercepter/offline-pwa.interceptor';
import { ReportComponent } from './pages/report/report.component';
import { Report2Component } from './pages/report2/report2.component';
import { LoginbackupComponent } from './pages/loginbackup/loginbackup.component';
import { HomeComponent } from './pages/home/home.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportNewComponent } from './pages/report-new/report-new.component';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export function tokenGetter() {
  let user = JSON.parse(localStorage.getItem('useer'));

  if (user && user.token) {
    return user.token;
  }
}

const JWT_Module_Options: JwtModuleOptions = {
  config: {
    tokenGetter: tokenGetter
  }
};

function isAppOpenedInIframe() {
  return window.top !== window.self;
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginbackupComponent,
    ForgotPassComponent,
    VinInformationComponent,
    ValidationComponent,
    ReportComponent,
    Report2Component,
    LoginbackupComponent,
    HomeComponent,
    ReportNewComponent

    // Base64Pipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    IonicModule.forRoot(),
    ComponentsModule,
    CommonratingcomponentsModule,
    CommonCompModule,
    VamModule,
    RatingModule,
    CommonRatingModule,
    ClickOutsideModule,
    ZXingScannerModule,
    GooglePlaceModule,

    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot(JWT_Module_Options),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isAppOpenedInIframe(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    RouterModule,
    NgbModule
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OfflinePwaInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    // { provide: LOCALE_ID, useValue: 'ar' }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
